module.exports = {
    isTest: function () {
        const environment = process.env.REACT_APP_ENV ?? '';
        if ('development' === environment) {
            return true;
        }

        if ('test' === environment) {
            return true;
        }

        if ('production' === environment) {
            return false;
        }

        // Fallback to old logic.
        const hostName = window.location.hostname;
        return (
            // local environments
            hostName.includes('localhost') ||
            // dev environments
            hostName.includes('pms.hc-dev') ||
            // staging
            hostName.includes('staging'));
    },
};
